/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import router from "../../router";
import { allowOnlyAuthorized } from "../../router/routeGuards";

import Compare from "./Compare.vue";
import AppHeaderForCompare from "../../components/layout/AppHeaderForCompare.vue";

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: "/compare/:compareId/:raceId",
      name: "compare",
      components: {
        default: Compare,
        header: AppHeaderForCompare,
      },
      beforeEnter: allowOnlyAuthorized(),
    },
  ]);
};
